import { useState, useEffect } from 'react';
import { fetchPrimarySchools } from '../utils/api';

export const usePrimarySchool = () => {
    const [PrimarySchools, setPrimarySchools] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await fetchPrimarySchools();

                // Extract school names from the response
                const fetchedPrimary = response.data.map(doc => ({
                    value: doc.properties.NAME, // Use the 'NAME' field for value
                    label: doc.properties.NAME // Use the 'NAME' field for label
                }));

                // Sort the schools alphabetically by label
                fetchedPrimary.sort((a, b) => a.label.localeCompare(b.label));

                setPrimarySchools(fetchedPrimary);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []); // Empty dependency array ensures this effect runs only once after the component mounts

    return { PrimarySchools, loading, error };
};
